import { renderPageClient } from './pageClient';

renderPageClient();
